import { render, staticRenderFns } from "./EpBdFactoryAreaForm.vue?vue&type=template&id=4961cbc0&"
import script from "./EpBdFactoryAreaForm.vue?vue&type=script&lang=js&"
export * from "./EpBdFactoryAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4961cbc0')) {
      api.createRecord('4961cbc0', component.options)
    } else {
      api.reload('4961cbc0', component.options)
    }
    module.hot.accept("./EpBdFactoryAreaForm.vue?vue&type=template&id=4961cbc0&", function () {
      api.rerender('4961cbc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/EpBdFactoryAreaForm.vue"
export default component.exports